import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-taux-remplissage',
  templateUrl: './taux-remplissage.component.html',
  styleUrls: ['./taux-remplissage.component.css']
})
export class TauxRemplissageComponent implements OnInit {

  @Input() public niveauRemplissage: number;

  niveauToDisplay: string;
  
  constructor() { }

  ngOnInit() {
    switch(this.niveauRemplissage) {
      case 0:
        this.niveauToDisplay = "Vide";
        break;
      case 25:
        this.niveauToDisplay = "1/4";
        break;
      case 50:
        this.niveauToDisplay = "1/2";
        break;
      case 75:
        this.niveauToDisplay = "3/4";
        break;
      case 100:
        this.niveauToDisplay = "Plein";
        break;
      default:
        break;
    }
  }

}
